/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Heatingtemperature1Inputs */



/**
* | output |
* | --- |
* | "Heating temperature" |
*
* @param {Br_History_Key_Heatingtemperature1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_heatingtemperature1 = /** @type {((inputs?: Br_History_Key_Heatingtemperature1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Heatingtemperature1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Heating temperature")
	return /** @type {LocalizedString} */ ("Température de chauffe")
});
export { br_history_key_heatingtemperature1 as "br_history_key_heatingTemperature" }